import { createSlice } from '@reduxjs/toolkit';
import { filter } from 'lodash';
import Axios from '../../utils/axiosInstance';

const initialState = {
  expenseList: [],
  expenseIdData: [],
  expensesId: null,
};

const slice = createSlice({
  name: 'expense',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setStoreId: (state, action) => {
      state.expensesId = action.payload;
    },

    // DELETE EXPENSE
    deleteExpense(state, action) {
      const deleteExpense = filter(state.expense, (expense) => expense.id !== action.payload);
      state.expense = deleteExpense;
    },

    // GET EXPENSE
    getExpenseListSuccess(state, action) {
      state.isLoading = false;
      state.expenseList = action.payload;
    },
    // Create EXPENSE
    createExpense(state, action) {
      state.isLoading = false;
      state.expense = action.payload;
    },

    ExpenseFindByID(state, action) {
      state.isLoading = false;
      state.expenseIdData = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { onToggleFollow, deleteExpense } = slice.actions;

// ----------------------------------------------------------------------

export function dispatchDeleteExpense(expensesId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await Axios.delete(`/expenses/${expensesId}`);
      dispatch(slice.actions.deleteExpense(expensesId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchNewExpense(expense) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.post('/expenses', expense);
      dispatch(slice.actions.createExpense(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function dispatchUpdateExpense(expense) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.put(`/expenses/${expense.id}`, expense);
      dispatch(slice.actions.createExpense(response.data.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getExpenseList() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get('/expenses');
      dispatch(slice.actions.getExpenseListSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getExpenseFindByID(id) {
  return async (dispatch) => {
    if (!id) return;

    dispatch(slice.actions.startLoading());
    try {
      const response = await Axios.get(`/expenses/${id}`);
      dispatch(slice.actions.ExpenseFindByID(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
